import type { IAnalyticsRepository } from '@src/domain/analytics/repository/analytics_repository';
import { AnalyticsEvent } from '@src/domain/analytics/value_objects/analytics_event';

/**
 * Track Event Use Case
 * Handles tracking of custom events in the application
 */
export class TrackEventUseCase {
    constructor(private readonly analyticsRepository: IAnalyticsRepository) { }

    async execute(params: {
        category: string;
        action: string;
        label?: string;
        value?: number;
        metadata?: Record<string, any>;
    }): Promise<void> {
        const event = AnalyticsEvent.create({
            category: params.category,
            action: params.action,
            label: params.label,
            value: params.value,
            metadata: params.metadata,
        });

        await this.analyticsRepository.trackEvent(event);
    }
}
